/*
  Automatically instantiates modules based on data-attrubiutes
  specifying module file-names.
*/

const moduleElements = document.querySelectorAll('[data-module]');

for (var i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i];
  const name = el.getAttribute('data-module');
  const Module = require(`./${name}`).default;
  new Module(el);
}

const instantiatedModules = new Map();

window.addEventListener('RequireBabelModule', function (e) {
    const Module = require(`./${e.detail.name}`).default;
    instantiatedModules.set(e.detail.key, new Module(e.detail.element));
}, false);

window.addEventListener('NewCheckboxTreeForSearchService', function (e) {
    instantiatedModules.get(e.detail.key)?.destroy();
});